import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client';

export interface SearchDealHit {
  id: string;
  code: string;
  codename: string;
  currentStage: string;
  companyName: string | null;
}
export interface SearchCompanyHit {
  id: string;
  name: string;
  sectorName: string | null;
}
export interface SearchOriginatorHit {
  id: string;
  name: string;
  typeName: string | null;
}
export interface SearchPersonHit {
  id: string;
  name: string;
  email: string | null;
  originatorName: string | null;
}

export interface SearchResponse {
  deals: SearchDealHit[];
  companies: SearchCompanyHit[];
  originators: SearchOriginatorHit[];
  people: SearchPersonHit[];
}

export const MIN_SEARCH_LENGTH = 2;

/**
 * Busca global (E7): GET /api/search?q=. Habilitado só com termo >= 2 chars (o backend também
 * filtra). `keepPreviousData`-like via `placeholderData` para não piscar entre teclas. O componente
 * já passa o termo com debounce.
 */
export function useGlobalSearch(q: string) {
  const term = q.trim();
  return useQuery({
    queryKey: ['search', term],
    queryFn: () => apiFetch<SearchResponse>(`/api/search?q=${encodeURIComponent(term)}`),
    enabled: term.length >= MIN_SEARCH_LENGTH,
    staleTime: 1000 * 30,
  });
}

export function totalHits(r: SearchResponse | undefined): number {
  if (!r) return 0;
  return r.deals.length + r.companies.length + r.originators.length + r.people.length;
}
